<div class="website-content" style="max-width:72rem;padding:0 var(--wa-spacing-x-large) var(--wa-spacing-x-large) var(--wa-spacing-x-large);">
	<div class="wa-stack wa-gap-l">
		<wa-button [routerLink]="['/plugins/web-awesome']" appearance="plain" variant="neutral">&larr; Back to Web Awesome</wa-button>
		<div class="wa-cluster" style="align-items:center;justify-content:space-between;">
			<h1 waHeading="xl" waText>WaStack</h1>
		</div>
		<p waBody="m" waColorText="quiet" waText>Vertical stack layout with configurable gap</p>
		<wa-details appearance="outlined" summary="Import, Interfaces & Constructors">
			<div class="wa-stack wa-gap-m">
				<div waCaption="s" waFontWeight="semibold" waText>IMPORT</div>
				<markdown [data]="mdContent_1144" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
				<div waCaption="s" waFontWeight="semibold" waText>CONSTRUCTORS</div>
				<markdown [data]="mdContent_1145" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
				<p waBody="s" waColorText="quiet" waText>Creates a vertical stack</p>
			</div>
		</wa-details>
		<wa-details open summary="Methods (1)">
			<table style="border-collapse:collapse;width:100%;">
				<thead>
					<tr style="border-bottom:2px solid var(--wa-color-neutral-200);">
						<th style="color:var(--wa-color-text-quiet);font-size:var(--wa-font-size-xs);font-weight:var(--wa-font-weight-semibold);padding:var(--wa-spacing-small);text-align:left;">Signature</th>
						<th style="color:var(--wa-color-text-quiet);font-size:var(--wa-font-size-xs);font-weight:var(--wa-font-weight-semibold);padding:var(--wa-spacing-small);text-align:left;">Description</th>
					</tr>
				</thead>
				<tbody>
					<tr style="border-bottom:1px solid var(--wa-color-neutral-100);">
						<td style="color:var(--wa-color-text-quiet);font-family:var(--wa-font-mono);font-size:var(--wa-font-size-xs);font-weight:var(--wa-font-weight-semibold);padding:var(--wa-spacing-small);">setGap(PageSize gap)</td>
						<td style="font-size:var(--wa-font-size-s);padding:var(--wa-spacing-small);">Sets the gap between children</td>
					</tr>
				</tbody>
			</table>
		</wa-details>
	</div>
</div>